module.exports = __webpack_public_path__ + "img/square.8f66a8a8.svg";